import { Helper } from '../Helper';
export class MapSomeHelper extends Helper {
    constructor(options) {
        super();
        this.each = options.each;
    }
    emit(sb, node, options) {
        sb.emitSysCall(node, 'Neo.Iterator.Create');
        sb.emitHelper(node, options, sb.helpers.rawIteratorSome({
            each: this.each,
        }));
    }
}

//# sourceMappingURL=MapSomeHelper.js.map
